import React, {useState, useEffect, useRef} from "react";
import axios from 'axios';
import { Navigate, useParams } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi"; 

const UserEdit = ()=>{
    const [userUuid, setUserUuid ] = useState('');
    const [roleId, setRoleId ] = useState('');
    const [email, setEmail ] = useState('');
    const [lastName, setLastName ] = useState('');
    const [firstName, setFirstName ] = useState('');
    const [redirect, setRedirect] = useState(false);
    const[roleList, setRoleList] = useState([]);
    const [page,setPage] = useState(1);
    const ref = useRef<HTMLInputElement>(null);

    let {id} = useParams();

    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`role?page=${page}`);
            setRoleList(data.data);
            //console.log(data); 

        }
        )();
    },[page]);

    useEffect(() =>{
        (
            async () => {
                 const {data} = await axios.get(`users/${id}`);
                 setUserUuid(data.user_uuid);
                 setRoleId(data.role_id);
                 setEmail(data.email);
                 setLastName(data.last_name);
                 setFirstName(data.first_name);
             }
             )();
        },[id]);
        const submit = async (e)=>{
            e.preventDefault();
            const {data} = await axios.put(`users/${id}`, {
            userUuid,
            role_id:parseInt(roleId),
            email,
            last_name:lastName,
            first_name:firstName,
        });
        //console.log(data);
        setRedirect(true);
    };
 
    if(redirect){
         return <Navigate to={'/users'} />
    }

    // Reorder roles so that the role with ID 2 is at the top
  const reorderedRoleList = roleList.sort((a, b) => {
    if (a.id === roleId) return -1;
    if (b.id === roleId) return 1;
    return 0;
  });

    return (
        <Wrapper pageTitle={'Edit User'}>
            <InnerNav createLink={'/userCreate'} listLink={'/users'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                     

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">FirstName </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="FirstName" value={firstName}
                        onChange = {e => setFirstName(e.target.value)} />
                    </label>

                    
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">LastName </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="LastName" value={lastName}
                        onChange = {e => setLastName(e.target.value)} />
                    </label>

                    
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Email </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Email" value={email}
                        onChange = {e => setEmail(e.target.value)} />
                    </label>


                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Role  </span>
                        <select
                            onChange={(e) => setRoleId(e.target.value)}
                            className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input"
                            value={roleId}
                            >
                            <option value="0">Choose Role</option>
                            {reorderedRoleList.map((role) => (
                                <option key={role.id} value={role.id}>
                                {role.name}
                                </option>
                            ))}
                        </select>
                    </label>



                     <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                         <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                         onClick={submit}
                         > <FiSave /> <span className="ml-3">Save</span> </button>
                         </label>
                     </div>
                 </div>
             </form>
         </Wrapper>
     );
};
export default UserEdit;